// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"424":"952d9c9e","453":"3f8714db","815":"e0acee02","913":"c040acc2"}[chunkId] + ".chunk.js";
};